export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}


export function overrideDateToJSONMethodToSerializeDateToLocalDateTime() {
  Date.prototype.toJSON = function () {
    return this.getFullYear() + '-' +
        ('0' + (this.getMonth() + 1)).slice(-2) + '-' +
        ('0' + this.getDate()).slice(-2) + 'T' +
        ('0' + this.getHours()).slice(-2) + ':' +
        ('0' + this.getMinutes()).slice(-2) + ':' +
        ('0' + this.getSeconds()).slice(-2) + '.' +
        ('00' + this.getMilliseconds()).slice(-3) + 'Z';
  };
}

export function overrideJSONParseToDeserializeDate() {
  const originalParse = JSON.parse;
  const dateRegex = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{2,3}))?)?Z?)?$/;

  JSON.parse = function (text, reviver) {
    return originalParse(text, (key, value) => {
      if (typeof value === 'string') {
        const match = value.match(dateRegex);
        if (match) return buildDate(...(match.slice(1) as [string, string, string, string?, string?, string?, string?]));
      }
      return reviver ? reviver(key, value) : value;
    });
  };

  function buildDate(
      year: string, month: string, day: string,
      hours = "0", minutes = "0", seconds = "0", milliseconds = "0"
  ) {
    return new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1, // Months are 0-based
      parseInt(day, 10),
      parseInt(hours ?? 0, 10),
      parseInt(minutes ?? 0, 10),
      parseInt(seconds ?? 0, 10),
      parseInt(milliseconds ?? 0, 10)
    );
  }
}

export function generateFormId(formControlName?: string): string {
  const randomSuffix = Math.floor(Math.random() * 100000);
  return `${formControlName ?? "f"}-${randomSuffix}`;
}

export function normalizedDate(date?: Date): string | undefined {
  if (!date || isNaN(date.getTime())) return undefined;

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0'); // Months are 0-based
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
}



export function parseIdListParam(queryParams: any, key: string): { ids: number[]; valid: boolean } {
  const param = queryParams[key]
  const result: { ids: number[]; valid: boolean } = {
    ids: [],
    valid: true
  };

  if (param && !Array.isArray(param)) {
    if (typeof param === 'string') {
      const idString: string = param;

      const parsedIds: number[] = idString
          .split(',')
          .map(s => s.trim())
          .filter(s => s.length > 0)
          .map(s => parseInt(s, 10))
          .filter(id => !isNaN(id));

      if (parsedIds.length > 0) {
        result.ids = parsedIds;
      }
    }
  } else if (Array.isArray(param)) {
    result.valid = false;
  }

  return result;
}

export function parseLocalDate(dateString?: string): Date | undefined {
  if (!dateString) return undefined;
  const [year, month, day] = dateString.split('-').map(Number);
  if (!year || !month || !day) return undefined;
  return new Date(year, month - 1, day);
}

